export default {corgi:{petition:{petition_update:{details:{back_to_dashboard:'Back to petition dashboard'}}}}};